import React, { createContext, FC, useContext } from 'react';

interface DebugProviderProps {
  shouldHighlightPresetContainers: boolean;
}

const debugContext = createContext<DebugProviderProps>({ shouldHighlightPresetContainers: false });

export const DebugFlagsProvider: FC = ({ children }) => {
  const search = window?.location?.search || '';
  const debugOptions: DebugProviderProps = {
    shouldHighlightPresetContainers: search.includes('addPanelDebug_shouldHighlightPresetContainers'),
  };

  return <debugContext.Provider value={debugOptions}>{children}</debugContext.Provider>;
};

export const useDebugFlags = () => useContext(debugContext);
